module.exports = __webpack_public_path__ + "img/linkedin.2ed03b21.svg";